import { IChecklistItemsDatasource } from './../datasources/checklist_items_datasource';
import { ChecklistItem } from './../builders/checklist_item_builder';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { IChecklistFilterAlgorithm } from '../strategies/checklist_filter_strategy';

export class ChecklistItemQuery implements IQuery {
  private _result: {
    list: ChecklistItem[];
    hasAnyChecklistItems: boolean;
    filter: IChecklistFilterAlgorithm;
  };

  constructor(QueryMediator: IQueryMediator, private ngChecklistItemsDatasource: IChecklistItemsDatasource) {
    QueryMediator.registerQuery(this, ngChecklistItemsDatasource);
  }

  run() {
    const checklistFilter = this.ngChecklistItemsDatasource.model.checklistFilter;
    const filterChecklist = checklistFilter.filterChecklist;
    const items = _.sortByAll<ChecklistItem>(this.ngChecklistItemsDatasource.values(), ['ordering']);
    this._result = {
      list: filterChecklist(items),
      hasAnyChecklistItems: _.size(items) > 0,
      filter: checklistFilter
    };

    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-checklist').service('ngChecklistItemQuery', ChecklistItemQuery);



// WEBPACK FOOTER //
// ./app/lib/checklist/queries/checklist_item_query.ts